import { customerOrderPricing, type CustomerOrderPricingInput } from "../../../../lib/ordering-pricing";
const money = (p: number) => `${p < 0 ? "−" : ""}£${(Math.abs(p) / 100).toFixed(2)}`;
/** Shared customer receipt for order history and tracking, including multi-shop children. */
export function CustomerOrderSummary({ order, hideDelivery = false, hideTotal = false }: {
  order: CustomerOrderPricingInput; hideDelivery?: boolean; hideTotal?: boolean;
}) {
  const pricing = customerOrderPricing(order);
  return <section aria-label="Price breakdown" className="min-w-0 rounded-2xl bg-slate-50 p-4 sm:p-5">
    <dl className="space-y-3 text-sm leading-relaxed text-slate-700">
      {pricing.rows.filter(row => !hideDelivery || !["delivery", "returnDelivery"].includes(row.key)).map(row =>
        <div key={row.key} className={`flex min-w-0 items-start justify-between gap-4 ${row.pence < 0 ? "font-semibold text-emerald-700" : ""}`}>
          <dt className="min-w-0 break-words">{row.label}</dt>
          <dd className="shrink-0 whitespace-nowrap font-medium tabular-nums">{money(row.pence)}</dd>
        </div>)}
      {!hideTotal && <div className="flex items-start justify-between gap-4 border-t border-slate-200 pt-4 text-base font-bold text-slate-950">
        <dt>Total paid</dt><dd className="shrink-0 whitespace-nowrap text-xl tabular-nums">{money(pricing.paidPence)}</dd>
      </div>}
    </dl>
  </section>;
}
